import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { getWalletTransctionHistory } from "./services/wallet.services";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router";

const WalletTransctionHistory = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const transctions = useAppSelector(
    (state) => state.wallet.walletTransctionHostory
  );
  const loading = useAppSelector((state) => state.wallet.loading);

  useEffect(() => {
    dispatch(getWalletTransctionHistory());
  }, []);

  const formatDateTime = (dateString: string) => {
    return dateString
      ? moment(dateString, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY hh:mm A")
      : "-";
  };

  return (
    <div className="container py-5">
      <div className="d-flex align-items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-link me-3"
          style={{
            color: "#00a34d",
            background: "white",
            padding: "8px",
          }}
        >
          <FaArrowLeft size={20} />
        </button>
        <h2 className="mb-0">Wallet Transactions</h2>
      </div>
      <div className="card border-0 shadow-sm">
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-4">
              <div
                className="spinner-border"
                style={{ color: "rgba(205, 200, 36, 1)" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table align-items-center mb-0">
                <thead
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #dee2e6",
                  }}
                >
                  <tr>
                    <th
                      className="text-uppercase text-dark text-xs font-weight-bolder ps-4 py-3"
                      style={{ width: "5%", minWidth: "50px" }}
                    >
                      Transction ID
                    </th>
                    <th
                      className="text-uppercase text-dark text-xs font-weight-bolder py-3"
                      style={{ width: "15%", minWidth: "120px" }}
                    >
                      Date & Time
                    </th>
                    <th
                      className="text-uppercase text-dark text-xs font-weight-bolder py-3"
                      style={{ width: "12%", minWidth: "100px" }}
                    >
                      Amount (₹)
                    </th>
                    <th
                      className="text-uppercase text-dark text-xs font-weight-bolder py-3"
                      style={{ width: "25%", minWidth: "150px" }}
                    >
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {transctions.length > 0 ? (
                    transctions.map((transction, index) => (
                      <tr key={transction.ID}>
                        <td className="ps-4 align-middle">
                          <p className="text-xs mb-0">{transction.ID}</p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">
                            {formatDateTime(transction.TransactionDate)}
                          </p>
                        </td>
                        <td className="align-middle">
                          <p
                            className="text-xs mb-0 fw-bold"
                            style={{
                              color:
                                transction?.TransactionType === "CREDIT"
                                  ? "#00a34d"
                                  : "#ff3636",
                            }}
                          >
                            {`${
                              transction?.TransactionType === "CREDIT"
                                ? "+ "
                                : "- "
                            } `}
                            {transction?.TransactionAmount?.toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 2,
                              }
                            )}
                          </p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">
                            {transction.TransactionRemarks || "-"}
                          </p>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center py-4">
                        <p className="text-sm text-muted mb-0">
                          No Transctions found
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletTransctionHistory;
